import { render, staticRenderFns } from "./ListBeverages.vue?vue&type=template&id=52888296&"
import script from "./ListBeverages.vue?vue&type=script&lang=js&"
export * from "./ListBeverages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports